import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { ArrowStylizedLg } from '../icons';

export const CarouselSectionArrow = ({
  sliderRef = null,
  direction = 'right',
  disabled = false,
  clickAnalyticsEvent
}) => {
  const handleArrowClick = () => {
    if (sliderRef.current) {
      if ('right' === direction) {
        sliderRef.current.slickNext();
      } else {
        sliderRef.current.slickPrev();
      }
      if ('function' === typeof clickAnalyticsEvent) {
        clickAnalyticsEvent();
      }
    }
  };

  return (
    <button
      className={classnames('btn-clear remove-click-styling flex', { 'text-gray-400': disabled, 'text-gray-900': !disabled })}
      onClick={handleArrowClick}
      disabled={disabled}
      aria-label={`arrow-${direction}`}
    >
      <ArrowStylizedLg
        className={`arrow-${direction}`}
        width={32}
        height={32}
        style={{ transform: 'left' === direction ? 'rotate(180deg)' : 'none' }}
      />
    </button>
  );
};

CarouselSectionArrow.propTypes = {
  sliderRef: PropTypes.object,
  direction: PropTypes.oneOf(['right', 'left']),
  disabled: PropTypes.bool,
  clickAnalyticsEvent: PropTypes.func
};
